import React, { PureComponent } from 'react';
import { Box, Paper, Typography, TextField } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { uuid } from 'utils';

class CompanyPerks extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      allPerks: [
        'Early stock',
        'Startup Atmosphere',
        'Free Beverage',
        'No dress code',
        'In house trainings',
        'Free Lunch',
      ],
      perk: '',
    };
  }

  onChangePerk = (e) => {
    this.setState({
      perk: e.target.value,
    });
  };

  addPerks = (e) => {
    if (e.key !== 'Enter') return;
    const { perks } = this.props;
    let array = [...perks, e.target.value];
    array = [...new Set(array)];
    const { onUpdateOrganization } = this.props;
    onUpdateOrganization('perks', array);
    this.setState({
      perk: '',
    });
  };

  handleDelete = (removePerk) => () => {
    const { perks } = this.props;
    const perksCopy = Array.from(perks);
    let array = perksCopy.filter((prek) => removePerk !== prek);
    const { onUpdateOrganization } = this.props;
    onUpdateOrganization('perks', array);
  };

  render() {
    const { perks } = this.props;
    const { perk } = this.state;

    return (
      <Paper square elevation={0} className="company-perks">
        <Box pb="25px">
          <Typography variant="body1" className="font-weight-500">
            Perks in the company
          </Typography>
        </Box>
        <Box pb="25px">
          <Typography variant="body2">Selected</Typography>
          {perks.map((perk) => {
            return (
              <Chip
                key={uuid()}
                label={perk}
                onDelete={this.handleDelete(perk)}
                variant="outlined"
                style={{ margin: '5px' }}
                color="primary"
              />
            );
          })}
        </Box>
        <Box>
          <TextField
            label="Add your Perks"
            placeholder="Type the relevant skills to find the match"
            variant="outlined"
            onChange={this.onChangePerk}
            value={perk}
            onKeyDown={this.addPerks}
            fullWidth
          ></TextField>
        </Box>
      </Paper>
    );
  }
}

export default CompanyPerks;
